import './answerOption.css'
import parse from 'html-react-parser';
const AnswerOption = (props)=>{
    const {isAnswer, on, oc, wrong} = props
    return(
        <label className={isAnswer && !wrong?'selected_option option':'option'}>
            <input type="radio" name="question" value={on} />
            <span className="option-text"><strong className="circle">{on}</strong>{parse(oc)} </span>            
        </label>
        /* <div className={isAnswer && !wrong?'answer_option answer':(wrong? 'answer_option wrong':'answer_option')}>
        <div className='option_num'><div style={{alignSelf: 'center'}}>{on}</div></div>
        <div className='option_content'>{parse(oc)}</div>
        </div> */
    )
}
export default AnswerOption